import { DynameatModel } from '@dynameat/models';

export class Group extends DynameatModel {
  constructor(props = {}) {
    super(props.id);
    this.id = props.id;
    this.translation_es = props.translation_es;
    this.translation_en = props.translation_en;
    this.code_name = props.code_name;
    this.color = props.color;
  }

  get translation() {
    return this.translateAttribute('translation');
  }
}
